
const from_server = {
    user_agreement: `https://s3-cms.rsv.ru/693ab4f9/%20%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5_v.2.pdf`,
    politic: `https://s3-cms.rsv.ru/legal/%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0%20%D0%B2%20%D0%BE%D1%82%D0%BD%D0%BE%D1%88%D0%B5%D0%BD%D0%B8%D0%B8%20%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D0%B8%20%D0%BF%D0%B5%D1%80%D1%81%D0%BE%D0%BD%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D1%85%20%D0%B4%D0%B0%D0%BD%D0%BD%D1%8B%D1%85.pdf`,
    agreement: `https://docs.google.com/gview?url=https://s3-cms.rsv.ru/legal/rsv/agreement.docx&embedded=true`,
};

export default {
    state: {
        legal: {},
    },
    mutations: {
        writeLegal: (state, data) => state.legal = data,
    },
    actions: {
        loadLegal: async ctx => {
            await ctx.dispatch('getContacts');

            const docs = ctx.getters.docLinks;

            if (docs['data-processing-policy']) {
                from_server.politic = docs['data-processing-policy'].link;
            }
            if (docs['terms-of-use']) {
                from_server.user_agreement = docs['terms-of-use'].link;
            }

            ctx.commit('writeLegal', from_server);
        },
    },
    getters: {
        legal: state => state.legal,
    },
};
